import { LoggedUserService } from '@/services/LoggedUserService';
import { ActiveTenantService } from '@/services/ActiveTenantService';
import { AbilityService } from '@/services/AbilityService';
import { GlobalConstantService } from '@/services/GlobalConstantService';
import { UserPreferencesService } from '@/services/UserPreferencesService';
import { MaintenanceIntervalService } from '@/services/MaintenanceIntervalService';
import { FeatureService } from '@/services/FeatureService';

// One sequence for both auth entry points — full-page bootstrap and the SPA local-login path.
// User first, then tenant init, then the scoped services: their first requests must already
// carry X-Tenant, or a multi-tenant user 400s on scoped endpoints (SiteInfo among them).
export async function refreshAuthenticatedSessionState(): Promise<void> {
  await LoggedUserService.setInterval(30).forceRefresh();
  ActiveTenantService.initFromUser(LoggedUserService.user.value);

  await Promise.all([
    AbilityService.forceRefresh(),
    // run() stops its own timer while logged out; forceRefresh() alone would never re-arm it.
    GlobalConstantService.start().forceRefresh(),
    UserPreferencesService.load(),
    MaintenanceIntervalService.load(),
    // Feature keys (PR-870). The router guard waits on this bootstrap, which is what makes a
    // plain isEnabled() read safe from any setup().
    FeatureService.load(),
  ]);
}
